/**
 * Fleet Probability page (day/explore PROBABILITY).
 *
 * Thin wrapper: renders the shared project-wide ProbabilityHistory page in `fleetDay` mode — the date
 * range is pinned to the day being viewed (no date-range picker) and the charts come from the
 * `fleet_probability` objects the fleet Probability builder writes (`/probability-builder?fleet=true`),
 * which the sidebar already lists as the PROBABILITY submenu in day mode.
 *
 * See reports/gp50/project/all/explore/ProbabilityHistory.tsx for the `fleetDay` behavior.
 */
import ProbabilityHistoryPage from "../../project/all/explore/ProbabilityHistory";

export default function FleetProbabilityPage(props: Record<string, unknown>) {
  return <ProbabilityHistoryPage {...props} fleetDay={true} />;
}
